<div class="tabs" [class.is-vertical-sub-menu]="isSubMenu && isVerticalSubMenu">
  <ul *ngIf="!isSubMenu">
    <li 
      *ngFor="let tab of menuTabs" 
      [class.is-hidden]="!isTabHidden(tab)"
      [class.is-active]="isActiveId(tab.id)"
      (click)="setActiveId(tab.id, true)"
      (keyup.enter)="setActiveId(tab.id)"
      [class.is-locked]="isLocked"
      [style.pointer-events]="isLocked ? 'none' : 'auto'"
      tabindex="0"
     data-ui-name="Li" data-ui-component="menu-bar" data-testid="menu-bar-li" [attr.data-entity-key]="tab.id" data-entity-type="tab">
      <a class="has-icon" data-ui-name="A" data-ui-component="menu-bar" data-testid="menu-bar-a" [attr.data-entity-key]="tab.id" data-entity-type="tab">
        <i *ngIf="tab.flagged? tab.flagged() : false" class="fa fa-info-circle" style="margin-right: 2px"></i>
        <span><tra [slug]="tab.caption"></tra></span>
        <span *ngIf="tab.isCountEnabled" style="margin-left:0.3em;">
          ({{tab.count()}})
        </span>
      </a>
    </li>
  </ul>

  <ul *ngIf="!!isSubMenu" class="sub-menu">
    <li
            *ngFor="let tab of menuTabs"
            [class.is-hidden]="!isTabHidden(tab)"
            [class.is-active]="isActiveId(tab.id)"
            (click)="setActiveId(tab.id)"
            [class.is-locked]="isLocked"
            [style.pointer-events]="isLocked ? 'none' : 'auto'"
     data-ui-name="Li" data-ui-component="menu-bar" data-testid="menu-bar-li-25f22ec" [attr.data-entity-key]="tab.id" data-entity-type="tab">
      <a data-ui-name="A" data-ui-component="menu-bar" data-testid="menu-bar-a-0d2db20" [attr.data-entity-key]="tab.id" data-entity-type="tab">
        <span>{{tab.caption}} </span>
        <span *ngIf="tab.isCountEnabled" style="margin-left:0.3em;">
          ({{tab.count()}})
        </span>
      </a>
    </li>
  </ul>
</div>
